import { render, staticRenderFns } from "./ShaftWrite.vue?vue&type=template&id=78f7a0f6&"
import script from "./ShaftWrite.vue?vue&type=script&lang=js&"
export * from "./ShaftWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports